import React, { useState } from 'react';

const Services = () => {
  const [activeTab, setActiveTab] = useState('estrategia');

  const services = {
    estrategia: {
      name: "Estrategia Corporativa",
      items: [
        "Planeación Estrategica",
        "Implementación de gobierno corporativo",
        "Definición de objetivos e indicadores clave (OKR)",
        "Analisis del contexto de la organización",
        "Analisis de riesgos estratégicos",
        "Transformación Organizacional"
      ]
    },
    sistemas: {
      name: "Sistemas de Gestión",
      items: [
        "Sistemas de gestión de calidad (ISO9001)",
        "Sistemas de gestión ambiental (ISO14001)",
        "Sistemas de gestión en SST (ISO45001)",
        "Seguridad en la cadena de suministro (BASC, OEA, ISO28000)",
        "Seguridad de la información (ISO27001)",
        "Auditoría interna",
        "Implementación de buenas prácticas de manufactura (BPM) y laboratorio (BPL)"
      ]
    },
    sst: {
      name: "Salud y Seguridad en el Trabajo (SST)",
      items: [
        "Implementación del SG-SST según Decreto 1072 y Resolución 312",
        "Análisis e inspección de puestos de trabajo",
        "Evaluaciones médicas ocupacionales",
        "Aplicación e intervención de BRP (Batería de Riesgo Psicosocial)",
        "Investigación de accidentes laborales",
        "Programas de vigilancia epidemiológica",
        "Plan estratégico de seguridad vial (PESV)",
        "Plan de Emergencias",
        "Profesiogramas",
        "Auditorías",
        "Formación"
      ]
    },
    procesos: {
      name: "Ingeniería de Procesos",
      items: [
        "Rediseño de procesos bajo enfoque Lean",
        "Definición y validación de layout de planta",
        "Análisis de tiempos y movimientos",
        "Estudio de capacidad instalada y balance de líneas",
        "Diseño e implementación de indicadores operativos",
        "Mapas de procesos y flujos de valor",
        "Diagnóstico y mejora continua (Kaizen, 5S, PDCA)",
        "Simulación de escenarios productivos",
        "Optimización de flujos logísticos"
      ]
    },
    cumplimiento: {
      name: "Cumplimiento",
      items: [
        "Trámite de licencias ambientales y sectoriales",
        "Sistemas de prevención de lavado de activos",
        "Programa de ética y anticorrupción",
        "Política de protección de datos personales",
        "Políticas de cumplimiento organizacional"
      ]
    },
    sostenibilidad: {
      name: "Sostenibilidad",
      items: [
        "Diseño de estrategias de sostenibilidad empresarial",
        "Construcción de informes de sostenibilidad (GRI, TCFD, SASB)",
        "Medición y gestión de huella de carbono",
        "Implementación de modelos de cumplimiento social (SMETA, BSCI, SA8000)",
        "Diseño e implementación de políticas de RSE",
        "Programas de compras sostenibles y evaluación de proveedores",
        "Asesoría en obtención de certificaciones sostenibles (Empresa B, Carbono Neutro, etc.)",
        "Capacitación a directivos en enfoque ESG"
      ]
    },
    adicionales: {
      name: "Servicios Adicionales",
      items: [
        "Fumigación",
        "Lavado de tanques",
        "Venta y recarga de extintores",
        "Elaboración de planos de emergencia"
      ]
    }
  };

  return (
    <section id="servicios" className="py-20 bg-[#f5f5f5]">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-[#1b1d1d] mb-16">Nuestros Servicios</h2>
        
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {Object.keys(services).map((key) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`px-5 py-2 rounded-full text-sm md:text-base font-medium transition-all duration-300 transform hover:-translate-y-1 hover:shadow-md ${activeTab === key ? 'bg-[#199ca5] text-white shadow-lg' : 'bg-white text-[#1b1d1d] border border-gray-200 hover:bg-gray-50'}`}
            >
              {services[key].name}
            </button>
          ))}
        </div>

        <div className="bg-white p-10 rounded-xl shadow-lg">
          <h3 className="text-3xl font-bold text-[#1b1d1d] mb-8 text-center">{services[activeTab].name}</h3>
          
          <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services[activeTab].items.map((service, index) => (
              <li key={index} className="flex items-start text-black bg-[#f5f5f5] p-4 rounded-lg shadow-sm transform transition-all duration-300 hover:scale-[1.02] hover:shadow-md">
                <svg className="w-6 h-6 text-[#199ca5] mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-lg">{service}</span>
              </li>
            ))}
          </ul>

          {/* Bloque de descarga de portafolio */}
          <div className="text-center mt-12">
            <h4 className="text-xl font-semibold text-[#1b1d1d] mb-2">¿Quieres conocer todo lo que hacemos?</h4>
            <p className="mb-4 text-[#4a4a4a]">Descarga nuestro portafolio completo con las 6 líneas de negocio y soluciones para MiPymes.</p>
            <a
              href="https://zielconsulting.com.co/portafolio-ziel.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#159aa2] text-white font-semibold py-3 px-6 rounded-2xl shadow hover:bg-[#117e84] transition"
            >
              📄 Descargar Portafolio
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
